module.exports = __webpack_public_path__ + "static/media/diamonds-icon.9a5ea73c.svg";